export const normaliseContactPermission = (contactPermission: unknown): boolean | undefined => {
  if (contactPermission === undefined || contactPermission === null || contactPermission === '') {
    return undefined;
  }

  if (
    contactPermission === true ||
    contactPermission === 'true' ||
    contactPermission === 1 ||
    contactPermission === '1'
  ) {
    return true;
  }

  if (
    contactPermission === false ||
    contactPermission === 'false' ||
    contactPermission === 0 ||
    contactPermission === '0'
  ) {
    return false;
  }

  return undefined;
};
